import {MessageCodes} from "../MessageCodes";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultTable from "../../../components/table/ResultTable";
import EmptyLine from "../EmptyLine";
import ResultText from "../ResultText";
import ComparisonCSName from "../ComparisonCSName";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function C7({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.CFW00A.error_id: {
            const onlyInBase = row.data.filter(x => x.type === 'only_in_base')
            const onlyInComparison = row.data.filter(x => x.type === 'only_in_comparison')

            const tableData = []
            if (onlyInBase.length > 0) {
                tableData.push({
                    riverStation: onlyInBase.map(x => x.cross_section).join(', '),
                    plan: globalVariables?.tar_plan_title || 'Comparison'
                })
            }
            if (onlyInComparison.length > 0) {
                tableData.push({
                    riverStation: onlyInComparison.map(x => x.cross_section).join(', '),
                    plan: globalVariables?.sel_plan_title || 'Base'
                })
            }

            return (
                <>
                    <ResultText>
                        The following cross sections are missing in the listed plans. Therefore, encroachment stations are not compared for these cross sections.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(62), textAlign: 'start'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(24), textAlign: 'start'}}>Plan</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {tableData.map((item, index) => (
                                <ResultRow key={index}>
                                    <ResultBodyCell style={{textAlign: 'start', verticalAlign: 'top'}}>{item.riverStation}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'start', verticalAlign: 'top'}}>{item.plan}</ResultBodyCell>
                                </ResultRow>
                            ))}
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.CFW00B.error_id: {
            const baseData = row.data.filter(x => x.type === 'base')
            const comparisonData = row.data.filter(x => x.type === 'comparison')

            let base = (<div></div>);
            if(baseData.length > 0) {
                base = (
                    <>
                        {globalVariables?.sel_plan_title || 'Base'} Plan:{' '}
                        <ComparisonCSName csNameList={baseData.map(x => x.cross_section)} />
                    </>
                )
            }

            let comparison = (<div></div>);
            if(comparisonData.length > 0) {
                comparison = (
                    <>
                        {globalVariables?.tar_plan_title || 'Comparison'} Plan:{' '}
                        <ComparisonCSName csNameList={comparisonData.map(x => x.cross_section)} />
                    </>
                )
            }
            return (
                <>
                    <ResultText>
                        The following cross sections do not have any defined encroachment stations in plan file because their encroachment method is not set as Method 1. Therefore, encroachment stations are not compared for these cross sections.
                    </ResultText>
                    <ResultText>
                        {base}
                        <br/>
                        {comparison}
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.CFW01.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in Encroachment Station placements between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plan at the following {row?.data?.length} cross sections.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell rowSpan={3} style={{textAlign: 'left', verticalAlign: 'bottom', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell colSpan={4} style={{textAlign: 'center'}}>
                                Encroachment Station (ft)
                            </ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell colSpan={2} style={{textAlign: 'center'}}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                            <ResultHeaderCell colSpan={2} style={{textAlign: 'center'}}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                        </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Left</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Right</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Left</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Right</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            row.data?.map(r => (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'left',}}><ComparisonCSName csName={r.cross_section} /></ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{r.base_left}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{r.base_right}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r.base_left, r.compare_left)}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r.base_right, r.compare_right)}</ResultBodyCell>
                                </ResultRow>
                            ))
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Compare.TTOPW001.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in left and right Encroachment Top Width between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plan at the following {row?.data?.length} cross sections.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell rowSpan={3} style={{textAlign: 'left', verticalAlign: 'bottom', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell colSpan={7} style={{textAlign: 'center'}}>
                                Top Width (ft)
                            </ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell colSpan={3} style={{textAlign: 'center'}}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                            <ResultHeaderCell colSpan={3} style={{textAlign: 'center'}}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right'}}>Difference</ResultHeaderCell>
                        </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(8)}}>Left</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(8)}}>Right</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(8)}}>Total</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(8)}}>Left</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(8)}}>Right</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(8)}}>Total</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>Total</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            row.data?.map(r => (
                                <ResultRow>
                                    <ResultBodyCell style={{textAlign: 'left'}}><ComparisonCSName csName={r.cross_section} /></ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{r?.base?.sel_topW_L}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{r.base?.sel_topW_R}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{r.base?.sel_topW}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r?.base?.sel_topW_L, r.compare?.tar_topW_L)}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r?.base?.sel_topW_R, r.compare?.tar_topW_R)}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(r?.base?.sel_topW, r.compare?.tar_topW)}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{r.diff}</ResultBodyCell>
                                </ResultRow>
                            ))
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}